import {
    FirstCommonHeaders,
    LastCommonHeaders,
} from './CommonHeaders.settings.js'

import {
    Attack6ColumnTooltipContent,
    Attack8ColumnTooltipContent,
    Attack10ColumnTooltipContent,
    FortBattlesColumnTooltipContent,
    ResourceColumnTooltipContent,
} from '../ClanManagement/tooltips'

export default [
    ...FirstCommonHeaders,
    {
        isSortable: true,
        icon: 'sorties-middle',
        key: 'sorties_middle',
        tooltipId: 'members-table-column-tooltip',
        tooltipTip: Attack6ColumnTooltipContent.tip,
    },
    {
        isSortable: true,
        icon: 'sorties-champion',
        key: 'sorties_champion',
        tooltipId: 'members-table-column-tooltip',
        tooltipTip: Attack8ColumnTooltipContent.tip,
    },
    {
        isSortable: true,
        icon: 'sorties-absolute',
        key: 'sorties_absolute',
        tooltipId: 'members-table-column-tooltip',
        tooltipTip: Attack10ColumnTooltipContent.tip,
    },
    {
        isSortable: true,
        icon: 'battles-attack',
        key: 'battles-attack',
        tooltipId: 'members-table-column-tooltip',
        tooltipTip: FortBattlesColumnTooltipContent.tip,
    },
    {
        isSortable: true,
        icon: 'industrial',
        key: 'industrial',
        tooltipId: 'members-table-column-tooltip',
        tooltipTip: ResourceColumnTooltipContent.tip,
    },
    ...LastCommonHeaders,
]



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/MembersTable/ClanModesHeaders.settings.js